import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/ui/button/Button.vue'
import SidePanel from '@/components/ui/sidePanel/SidePanel.vue'
import { onBeforeMount, provide, watch } from 'vue'
import BaseTable from '../../../ui/components/baseTable/BaseTable.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import Input from '@/components/ui/input/Input.vue'
import EmptyTable from '@/components/ui/emty-table/EmptyTable.vue'
import ContextMenu from '@/components/ui/contextMenu/ContextMenu.vue'
import ConfirmationModal from '@/components/ui/confirmation-modal/ConfirmationModal.vue'
import SimpleTag from '@/@web/ui/components/SimpleTag.vue'
import { fireRiskApi } from '@/services/clients/AxiosClients'
import ExclusionZoneLayout from '../layouts/ExclusionZone.layout.vue'
import { ExclusionZoneRepositoryApiAdapter } from '@/@core/exclusion-zone/infra/ExclusionZoneRepositoryApi.adapter'
import { ExclusionZoneViewModel } from '../viewmodels/ExclusionZone.viewmodel'
import { MonitoredAreaRepositoryApiAdapter } from '@/@core/monitored-area/infra/monitored-area-repository-adapter/MonitoredAreaRepositoryApi.adapter'
import ExclusionZoneForm from '../components/ExclusionZoneForm.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExclusionZone.page',
  setup(__props) {

const repository = new ExclusionZoneRepositoryApiAdapter(fireRiskApi)
const monitoredAreaRepository = new MonitoredAreaRepositoryApiAdapter(fireRiskApi)

const vm = new ExclusionZoneViewModel(repository, monitoredAreaRepository)

provide('exclusion-zone-view-model', vm)

watch(vm.openForm, (value) => {
	if (!value) vm.resetState()
})

onBeforeMount(() => vm.getExclusionZones())

return { __sfc: true,repository, monitoredAreaRepository, vm, Button, SidePanel, BaseTable, Pagination, Input, EmptyTable, ContextMenu, ConfirmationModal, SimpleTag, ExclusionZoneLayout, ExclusionZoneForm }
}

})